// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"d5e9b2b6","107":"f523dcf1","109":"24d60b60","271":"110bd0f7","575":"2d74f5ca"}[chunkId] + ".chunk.js";
};